import {
  AfterViewChecked,
  Component,
  ElementRef,
  inject,
  ViewChild
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'app-layout',
  imports: [RouterOutlet],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss'
})
export class LayoutComponent implements AfterViewChecked {
  private readonly utilityService = inject(UtilityService);

  @ViewChild('container', { static: false })
  container!: ElementRef<HTMLElement>;

  ngAfterViewChecked() {
    this.emitContentHeight();
  }

  emitContentHeight() {
    const divHeight = this.container.nativeElement.offsetHeight;
    const remValue = divHeight / 14;
    this.utilityService.emitPropToParent('contentHeight', remValue);
  }
}
